import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import ReactLoading from "react-loading";
import IncomeNotificationHistoryTable from "../../components/Tables/IncomeNotificationHistoryTable";

class IncomeNotificationHistory extends React.Component {
    constructor(props) {
        super(props);
        this.qrRef = React.createRef();
        this.state = {
            isLoad:false,
            loading:false,
        }
    }
 async componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {userPermissions} = this.props;
    const userHasViewNotificationHistory = userPermissions.includes('view notification history');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
            <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Gelen Bildirimler"
                Breadcrumb={[
                  {name: "Bildirimler", navigate: ""},
                  {name: "Gelen Bildirimler", navigate: ""},
                ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="body">
                    <h6>Gelen Bildirimler</h6>
                    <div className="col-lg-12">
                      {userHasViewNotificationHistory ?
                          <IncomeNotificationHistoryTable></IncomeNotificationHistoryTable>
                          : ""}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
        ;
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(IncomeNotificationHistory)));
